<template>
  <section class="container-fluid p-0 bodyArea">
    <div class="justify-content-start">
      <div class="pageHeader row justify-content-between">
        <div>Session Details</div>
      </div>
    </div>

    <div v-if="$auth.isAuthenticated" class="table-responsive mt-4 tableWrapper shadow p-3 rounded">
      <table>
        <tbody>
          <tr>
            <th>Type</th>
            <td class="px-2"></td>
          </tr>
          <tr>
            <th>Start time</th>
            <td class="px-2">{{ participantData.startTimeInLocal }}</td>
          </tr>
          <tr>
            <th>End time</th>
            <td class="px-2">{{ participantData.endTimeInLocal }}</td>
          </tr>
          <tr>
            <th>Node</th>
            <td class="px-2"></td>
          </tr>
          <tr>
            <th>Tx codec</th>
            <td class="px-2"></td>
          </tr>
          <tr>
            <th>Tx bitrate(kbps)</th>
            <td class="px-2"></td>
          </tr>
          <tr>
            <th>Tx resolution</th>
            <td class="px-2"></td>
          </tr>
          <tr>
            <th>Tx framerate</th>
            <td class="px-2"></td>
          </tr>
          <tr>
            <th>Tx packets sent</th>
            <td class="px-2"></td>
          </tr>
          <tr>
            <th>Tx packets lost</th>
            <td class="px-2"></td>
          </tr>
          <tr>
            <th>Rx codex</th>
            <td class="px-2"></td>
          </tr>
          <tr>
            <th>Rx bitrate(kbps)</th>
            <td class="px-2"></td>
          </tr>
          <tr>
            <th>Rx resolution</th>
            <td class="px-2"></td>
          </tr>
          <tr>
            <th>Rx framerate</th>
            <td class="px-2"></td>
          </tr>
          <tr>
            <th>Rx packets received</th>
            <td class="px-2"></td>
          </tr>
          <tr>
            <th>Rx packets lost</th>
            <td class="px-2"></td>
          </tr>
          <tr></tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import router from '../router';

Vue.use(VueToast);

export default {
  name: 'Participant',

  data() {
    return {
      participantData: {},
      detailsLoading: false,
    };
  },
  async created() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      if (!this.$auth.isAuthenticated) {
        return;
      }

      this.participantData = this.$route.params.participant;

      if (!this.participantData) {
        return router.replace('/calls');
      }

      this.participantData = JSON.parse(this.participantData).item;
    },
  },
};
</script>
<style lang="scss">
body .dropdown .dropdown-input {
  border: none !important;
  padding: 0 15px !important;
  background: none !important;
  font-size: 16px !important;
}

body .dropdown.dropdownList .dropdown-input {
  color: #fff !important;
  border: none !important;
  padding: 0 15px !important;
  background: none !important;
  font-size: 14px !important;
}

body .dropdown .dropdown-input:focus,
body .dropdown .dropdown-input:focus-visible {
  outline: none;
}

.dropdownList input::-webkit-input-placeholder {
  color: #fff !important;
}

::-webkit-scrollbar {
  width: 5px;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #d7d7d7 !important;
  border-radius: 10px;
}

::-webkit-scrollbar-track {
  background: #fafafa !important;
}
</style>

<style lang="scss" scoped>
@font-face {
  font-family: GTWalsheimPro-Regular;
  src: url(../assets/fonts/GTWalsheimPro-Regular.eot);
  src:
    url(../assets/fonts/GTWalsheimPro-Regular.eot) format('embedded-opentype'),
    url(../assets/fonts/GTWalsheimPro-Regular.ttf) format('truetype'),
    url(../assets/fonts/GTWalsheimPro-Regular.svg) format('svg');
  font-weight: normal;
  font-style: normal;
}

*,
:after,
:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

body,
html {
  font-family: GTWalsheimPro-Regular !important;
  background: #fff !important;
  font-size: 16px;
  overflow-x: hidden;
}

b,
strong {
  font-weight: 500;
}

button,
html input[type='button'],
input[type='reset'],
input[type='submit'] {
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled],
html input[disabled] {
  cursor: default;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
  outline: 0 !important;
}

a,
a img,
a:active,
a:focus,
button:focus,
a:hover {
  outline: 0 !important;
  -webkit-transition: all 0.35s;
  -moz-transition: all 0.35s;
  transition: all 0.35s;
  text-decoration: none;
  cursor: pointer;
  color: #5ed1d1;
}

a:hover {
  text-decoration: underline;
}

img {
  border: 0 !important;
}

a:focus:not(:hover),
button:focus:not(:hover) {
  outline: 0;
}

::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: rgba(4, 78, 89, 1) !important;
}

::-moz-placeholder {
  /* Firefox 19+ */
  color: rgba(4, 78, 89, 1) !important;
}

:-ms-input-placeholder {
  /* IE 10+ */
  color: rgba(4, 78, 89, 1) !important;
}

:-moz-placeholder {
  /* Firefox 18- */
  color: rgba(4, 78, 89, 1) !important;
}

::-moz-selection {
  /* Code for Firefox */
  color: #fbeeef;
  background: #202533;
}

::selection {
  color: #fbeeef;
  background: #202533;
}

/* Scroll Bar Styling */

/* width */
::-webkit-scrollbar {
  width: 5px;
  border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f2fdff;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #a6e3f0;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #a6e3f0;
  border-radius: 10px;
}

/* Checkbox CSS ends here */
.bodyArea {
  font-family: GTWalsheimPro-Regular;
}
.pageHeader {
  height: 70px;
  color: #bcbcbc;
  background: #484848;
  font-size: 22px;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
}

.loader {
  border: 3px solid #f3f3f3; /* Light grey */
  border-top: 3px solid #484848; /* Blue */
  border-radius: 50%;
  width: 35px;
  height: 35px;
  animation: spin 1.5s linear infinite;
}
.tableWrapper {
  font-size: 14px;
  margin: auto;
  width: 97%;
  overflow: auto;
  border: 1px solid lightgray;
}

body select {
  width: 100px !important;
  overflow: hidden !important;
  white-space: nowrap;
  text-overflow: ellipsis;
}

body select option {
  width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #6a6a6a;
}

body select[data-v-33144d13] {
  width: 200px !important;
  overflow: hidden !important;
  white-space: nowrap;
  text-overflow: ellipsis;
}

th {
  height: 50px;
  width: 35%;
}
</style>
